import BaseResource from './BaseResource'

export default class RoleMappings extends BaseResource {
  static endpoint = '/api/v1/rolemappings' ///profile
}
